<template>
  <div
    class="align-center justify-center"
    eager
    contained
    persistent
  >
    <v-card
      v-if="userKeywordGroupStore.isSaveKeyword"
      id="saveKeyword"
      width="450"
      min-width="0"
      :max-width="`${85*props.vw}px`"
    >
      <v-card-title>
        검색 키워드 저장
      </v-card-title>
      <v-card-text class="py-2 px-4">
        <div class="d-flex align-center justify-space-between pa-2">
          <div>검색 키워드</div>
          <input
            type="text"
            v-model="userKeywordGroupStore.keyword"
            maxlength="200"
            hide-details
            style="width: 68%; min-height: 40px; padding: 8px 6px 8px 16px; font-size: 16px;"
            class="ms-4 input-border-effect"
          >
        </div>
        <!-- 그룹 선택 select 박스 -->
        <div class="d-flex align-center justify-space-between pa-2">
          <div>그룹 선택</div>
          <v-select
            v-model="userKeywordGroupStore.selectedGroupSeq_forSaveKeyword"
            :items="userKeywordGroupStore.copiedKeywordData"
            item-title="groupName"
            item-value="groupSeq"
            density="compact"
            hide-details
            variant="outlined"
            style="width: 70%;"
            class="select-border-effect"
            :class="!mobile ? 'ms-16' : 'ms-9'"
          ></v-select>
        </div>
        <v-card-actions class="px-0 pt-4 ">
          <v-btn color="surface-variant" variant="flat" @click="closeSaveKeywordOverlay();">취소</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="flat"
            @click="saveKeywordClick();"
          >저장</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>

    <v-card
      v-if="!userKeywordGroupStore.isSaveKeyword"
      id="editGroup"
      width="900"
      min-width="0"
      :max-width="`${95 * props.vw}px`"
    >
      <v-card-title>
        그룹 관리
      </v-card-title>
      <v-card-text class="py-2 px-1">
        <div class="d-flex justify-space-between pa-2">

          <div style="width: 48%; height: 50%;">
            <!-- 그룹 목록 영역 -->
            <div style="font-size: 16px;" class="ms-1">
              그룹 목록
            </div>
            <div class="mt-1 input-border-effect" style="height: 240px; overflow-y: auto;">
              <v-list
                v-if="userKeywordGroupStore.copiedKeywordData?.length"
                id="groupList"
                density="compact"
                nav
                lines="one"
                class="h-100"
                style="overflow: hidden auto;"
                :mandatory="true"
              >
                <v-list-item
                  v-for="(group, index) in userKeywordGroupStore.copiedKeywordData"
                  :key="index"
                  :value="group.groupSeq"
                  :id="`groupListItem-` + group.groupSeq"
                  :ripple="false"
                  class="group-list-item w-100 cursor-pointer"
                  @click="selectedGroupSeq_forEditGroup = group.groupSeq"
                >
                  <div class="d-flex align-center justify-space-between w-100">
                    <!-- 추가/삭제/수정 표시 배너 (input 왼쪽) -->
                    <!-- 추가된 그룹은 목록에서 바로 삭제됨.  -->
                    <div v-if="group.isNew || group.isDeleted || group.isModified" class="status-banner-container">
                      <div class="status-banner" :style="{ backgroundColor : group.isDeleted ? 'red' : '#3182f6' }">
                        {{ group.isNew? '추가' : group.isDeleted ? '삭제' : '수정' }}
                      </div>
                    </div>

                    <!-- 그룹명 수정 가능 영역 -->
                    <input
                      type="text"
                      :value="group.groupName"
                      @input="updateGroupName_temp(group.groupSeq, $event.target.value)"
                      :readonly="group.immutable"
                      class="input-border-effect flex-grow-1"
                      :style="{maxWidth: group.isNew || group.isDeleted || group.isModified ? 'calc(100% - 80px)' : 'calc(100% - 50px)'}"
                      hide-details
                    />

                    <!-- 삭제 버튼 -->
                    <div class="ms-2" style="width: 40px; min-width: 40px; height: 33px; overflow: hidden;">
                      <v-btn
                        v-if="!group.immutable"
                        style="width: 100%; min-width: 100%; height: 100%; min-height: 100%; padding: 0px 8px; font-size: 14px;"
                        :color="group.isDeleted ? 'red' : 'primary'"
                        :ripple="false"
                        @click="removeKeywordGroup_temp(group.groupSeq);"
                      >
                        {{ group.isDeleted ? '취소' : '삭제' }}
                      </v-btn>
                    </div>
                  </div>
                </v-list-item>
              </v-list>
            </div>

            <!-- 그룹 추가 입력 & 버튼 -->
            <div class="d-flex align-center mt-2 w-100" style="overflow: hidden;">
              <input
                type="text"
                v-model="newKeywordGroupName"
                class="input-border-effect flex-grow-1"
                style="padding: 5px 8px; min-height: 40px; width: 100%; max-width: calc(100% - 36px);"
                @keyup.enter="addNewGroup_temp();"
              />
              <v-btn class="ms-2" color="primary" variant="flat" style="width: 36px; max-width: 36px; min-height: 40px;" @click="addNewGroup_temp();">
                그룹 추가
              </v-btn>
            </div>
          </div>

          <!-- 검색 키워드 목록 영역 -->
          <div style="width: 48%; height: 50%;">
            <div style="font-size: 16px;" class="ms-1">
              검색 키워드 목록
            </div>
            <div
              class="mt-1"
              :class="{
                'keyword-deletedGroup-border-effect': selectedGroup?.isDeleted,
                'input-border-effect': !selectedGroup?.isDeleted
              }"
              style="height: 240px; overflow-y: auto;"
            >
              <div v-if="selectedGroup?.isDeleted" class="overlay">
                삭제 예정 그룹
              </div>
              <v-list
                v-if="(selectedGroup && Object.keys(selectedGroup).length !== 0)"
                id="keywordList"
                density="compact"
                nav
                lines="one"
                class="h-100"
                style="overflow: hidden auto;"
                :mandatory="true"
              >
                <v-list-item
                  v-for="keywordInfo in selectedGroup.keywords"
                  :key="keywordInfo.kwSeq"
                  :value="keywordInfo.kwSeq"
                  :id="`keywordListItem-`+keywordInfo.kwSeq"
                  :ripple="false"
                  class="w-100 cursor-pointer"
                  style="padding: 5px 6px;"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div v-if="keywordInfo.isDeleted" class="status-banner-container">
                      <div class="status-banner" style="background-color : red;">
                        {{ '삭제' }}
                      </div>
                    </div>
                    <div class="flex-grow-1 keyword-text-from-edit-group">{{ keywordInfo.keyword }}</div>
                    <v-btn
                      class="ms-2"
                      style="width: 50px; min-width: 50px; height: 33px; padding: 0px 8px; font-size: 14px;"
                      :color="keywordInfo.isDeleted ? 'red' : 'primary'"
                      :ripple="false"
                      @click="removeKeywordGroup_temp(selectedGroup.groupSeq, keywordInfo.kwSeq);"
                    >
                      {{ keywordInfo.isDeleted ? '취소' : '삭제' }}
                    </v-btn>
                  </div>
                </v-list-item>
              </v-list>
            </div>
            <div class="mt-2 ms-2">
              <p style="font-size: 12px; color: #666;">
                * 검색 키워드 저장은 검색창의 '저장' 버튼을 통해 가능합니다.
              </p>
              <!-- 모바일일 때 사용 가능... -->
              <!-- <p style="font-size: 12px; color: #666;">
                * 검색 키워드 저장은 <br>
                  검색창의 '저장' 버튼을 통해 가능합니다.
              </p> -->
            </div>

          </div>

        </div>

        <!-- 수정사항 적용/취소 버튼 -->
        <v-card-actions id="save-keyword-btn">
          <v-spacer></v-spacer>
          <v-btn color="green" variant="flat" @click="resetAll();">초기화</v-btn>
          <v-btn color="primary" variant="flat" @click="applyAllClick();">적용</v-btn>
          <v-btn color="surface-variant" variant="flat" @click="closeSaveKeywordOverlay();">취소</v-btn>
        </v-card-actions>

      </v-card-text>
    </v-card>
  </div>

</template>

<script setup>
  import { ref, computed, nextTick } from "vue";
  import { useDisplay } from 'vuetify'
  const { mobile } = useDisplay();

  import { useUserAlertStore, useUserKeywordGroupStore } from '@/store';
  import { commonJS, userJS } from "@/assets/js";
  const userKeywordGroupStore = useUserKeywordGroupStore();
  const userAlertStore = useUserAlertStore();

  const props = defineProps({
    vw: Number,
  });
  // const $emit = defineEmits([,]);

  /**
   * 검색 키워드 저장 작업창 : 저장 기능
   * 실제로 저장.
   */
  async function saveKeywordClick(){

    if (userKeywordGroupStore.keyword.trim() === '') {
      alert('저장할 검색 키워드를 입력해주세요.');
      return;
    }

    try {
      // 빈 공백 둘 이상이면 하나로 줄이기
      const cleanedKeyword = userKeywordGroupStore.keyword.split(' ').filter(Boolean).join(' ');

      let params = new FormData();
      params.append('keyword', cleanedKeyword);
      params.append('kwGroupSeq', userKeywordGroupStore.selectedGroupSeq_forSaveKeyword);

      let res = await userJS._api.postAddKeyword(params);

      if (res && res.success) {
          userAlertStore.$resetAllAlert();

          // 알림 띄우기
          userAlertStore.$changeAlertInfo({
            status: 'keyword-added',
          });
          userAlertStore.$changeAlertFT('keyword', 'add');

        userKeywordGroupStore.$showKeywordList();
      }
      closeSaveKeywordOverlay();
    } catch (error) {
      console.error("키워드 저장 중 오류 발생:", error);
    }
  };

  /**
   * 검색 키워드 저장 작업창 : 닫기 기능
   */
  function closeSaveKeywordOverlay() {
    resetAll();

    userKeywordGroupStore.isKeywordGroupOverlayOn = false;
  };

  const newKeywordGroupName = ref('');                            // 새 그룹 이름
  const selectedGroupSeq_forEditGroup = ref(null);                    // 선택된 그룹 시퀀스 from 그룹관리 작업창
  const selectedGroup = computed(()=>{                            // 선택된 그룹 객체
    return userKeywordGroupStore.copiedKeywordData?.find(group => group.groupSeq === selectedGroupSeq_forEditGroup.value) || null;
  });

  /**
   * 그룹 목록 갱신
   * at 그룹관리 작업창
   */
  function resetAll(){
    newKeywordGroupName.value = '';
    userKeywordGroupStore.newKeywordGroupName = '';
    selectedGroupSeq_forEditGroup.value = null;

    userKeywordGroupStore.keyword = '';
    userKeywordGroupStore.selectedGroupSeq_forSaveKeyword = null;

    // css - 기존 그룹 선택 상태 해제
    const groupListItems = document.querySelectorAll('.group-list-item');
    groupListItems.forEach(item => {
      item.classList.remove('v-list-item--active'); // 기존 선택 해제
    });

    nextTick(()=>{// 작업창(모달창 띄울 때마다 스크롤이 맨 위로 향하도록)
      const gList = document.getElementById('groupList');
      if (gList) {
        gList.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      const kList = document.getElementById('keywordList');
      if (kList) {
        kList.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    })

    // 그룹, 키워드 모두 갱신 기능
    userKeywordGroupStore.copiedKeywordData = userKeywordGroupStore.keywordData.map(originalGroup => ({
      groupSeq: originalGroup.groupSeq,
      groupName: originalGroup.groupName,
      immutable: originalGroup.immutable,
      keywords: JSON.parse(JSON.stringify(originalGroup.keywords)), // 깊은 복사
    }));

    // 그룹만 갱신 기능
    // userKeywordGroupStore.copiedKeywordData = userKeywordGroupStore.copiedKeywordData
    // .filter(group => userKeywordGroupStore.keywordData.some(originalGroup => originalGroup.groupSeq === group.groupSeq)) // 원본에 없는 그룹은 삭제
    // .map(group => {
    //   const originalGroup = userKeywordGroupStore.keywordData.find(original => original.groupSeq === group.groupSeq);
    //   return {
    //     groupName: originalGroup.groupName,
    //     immutable: originalGroup.immutable,
    //     groupSeq: originalGroup.groupSeq,
    //     keywords: JSON.parse(JSON.stringify(group.keywords)) // 검색 키워드 수정사항은 갱신 없이 깊은 복사
    //   };
    // });

    // 키워드만 갱신 기능
    // userKeywordGroupStore.copiedKeywordData.forEach((group, index) => {
    //   // 현재 화면에 띄운 검색 키워드 목록에 대해서만 && 삭제하지 않을 그룹에 대해서만
    //   if(group.groupSeq == selectedGroupSeq_forEditGroup.value && !group.isDeleted){
    //     const originalGroup = userKeywordGroupStore.keywordData.find(g => g.groupSeq === group.groupSeq);

    //     if (originalGroup) {
    //       // 원본 데이터를 기반으로 키워드만 갱신 (깊은 복사)
    //       group.keywords = JSON.parse(JSON.stringify(originalGroup.keywords));
    //     } else {
    //       // 새롭게 추가된 그룹의 키워드를 삭제
    //       group.keywords = [];
    //     }
    //   }
    // });
  }

  /**
   * 그룹관리 작업창 : 그룹 추가 기능
   * '적용' 버튼 클릭하여 applyAllClick() 호출 시 실제로 추가됨
   */
  async function addNewGroup_temp(){
    if (newKeywordGroupName.value.trim() === '') {
      alert('그룹 이름을 입력해주세요.');
      return;
    }

    // groupSeq 중에 제일 큰 값 구하기
    const maxGroupSeq = Math.max(...userKeywordGroupStore.copiedKeywordData.map(g => g.groupSeq));
    // 새 그룹 객체 생성
    const newGroup = {
      groupSeq: maxGroupSeq+1,
      groupName: newKeywordGroupName.value,
      keywords: [],
      isNew: true,
    };
    // 임시 데이터 리스트에 새 그룹 생성
    await userKeywordGroupStore.copiedKeywordData.push(newGroup);

    selectedGroupSeq_forEditGroup.value = newGroup.groupSeq; // -> selectedGroup computed값을 변경하여 검색 키워드 목록을 변경하기 위함.

    // css - 그룹명 입력창 비우기
    newKeywordGroupName.value = '';
    // css - 기존 선택 해제
    const groupListItems = document.querySelectorAll('.group-list-item');
    groupListItems.forEach(item => {
      item.classList.remove('v-list-item--active'); // 기존 선택 해제
    });
    // css - 추가한 그룹 선택 상태로!
    const targetItem = document.getElementById(`groupListItem-${newGroup.groupSeq}`);
    if (targetItem) {
        targetItem.classList.add('v-list-item--active');
    }
    // css - 스크롤 맨 아래로!
    const list = document.getElementById('groupList');
    if (list) {
      list.scrollTo({
        top: list.scrollHeight, // 스크롤을 맨 아래로
        behavior: 'smooth' // 부드럽게 스크롤
      });
    }
  };

  /**
   * 그룹관리 작업창 : 그룹명 수정 버튼
   * 1) 저장된 그룹명 텍스트 or 2) 그룹명 수정 가능한 입력창 보여주고, '수정'버튼은 '저장'버튼으로 변경하는 토글 기능.
   */
  function updateGroupName_temp(groupSeq, newName) {
    const originalGroup = userKeywordGroupStore.keywordData.find(// 수정 적용 전 원래 키워드 목록 데이터와 비교하기.
      group => group.groupSeq === groupSeq
    );

    // 기존에 없었던 새로운 그룹에 대해서는 수정상태를 따지지 않도록.
    if(!originalGroup) {
      let gIndex = userKeywordGroupStore.copiedKeywordData.findIndex(g=>g.groupSeq == groupSeq);
      // 새로운 그룹은 이 그룹명으로 추가되도록.
      userKeywordGroupStore.copiedKeywordData[gIndex].groupName = newName;
      return;
    }

    userKeywordGroupStore.copiedKeywordData.forEach(g=>{
      if(g.groupSeq == groupSeq){
        // ( userKeywordGroupStore.keywordData의 )원래 이름과 같다면 수정 상태 해제
        g.isModified = originalGroup.groupName == newName ? false : true;
        g.groupName = newName; // 입력창에서 수정된 그룹명 바로바로 보이도록, 새로 추가될 그룹은 이 그룹명으로 추가되도록.
      }
    })
  }

    /**
   * 그룹관리 작업창 : 그룹 삭제, 키워드 삭제 기능
   * '적용' 버튼 클릭하여 applyAllClick() 호출 시 실제로 삭제됨
   */
  function removeKeywordGroup_temp(groupSeq = null, keywordSeq = null) {
    const gIndex = userKeywordGroupStore.copiedKeywordData.findIndex(group => group.groupSeq === groupSeq);
    if (gIndex === -1) return;

    const group = userKeywordGroupStore.copiedKeywordData[gIndex];

    if (keywordSeq) {
      const kIndex = group.keywords.findIndex(k => k.kwSeq === keywordSeq);
      if (kIndex !== -1) group.keywords[kIndex].isDeleted = !group.keywords[kIndex].isDeleted;
    } else {
      if(group.isNew) userKeywordGroupStore.copiedKeywordData.splice(gIndex, 1); // 추가될 그룹은 목록에서 바로 삭제
      group.isDeleted = !group.isDeleted;
    }
  }

  /**
   * 그룹관리 작업창의 '적용' 버튼 클릭 시 기능 : API 호출해서 수정사항( userKeywordGroupStore.copiedKeywordData ) 한꺼번에 적용
  */
  async function applyAllClick(){

    let deleteGroupParams = {kwGroupSeqs: []}; // 그룹 삭제 파라미터
    let deleteKeywordParams = {kwGroupSeqs: [], kwSeqs: []}; // 키워드 삭제 파라미터
    let modifyGroupParams = {kwGroupSeqs: [], groupNames: []}; // 그룹 수정 파라미터
    let addGroupParams = {groupNames: []}; // 그룹 추가 파라미터

    // 파라미터 채우기 ================================================================
    for (const g of userKeywordGroupStore.copiedKeywordData) {
      // 1. 그룹 삭제
      if(g.isDeleted){
        if(!g.isNew) {// 기존 그룹이 아니므로 삭제 API를 호출할 필요 없음.
          deleteGroupParams.kwGroupSeqs.push(g.groupSeq);
        }
      } else {
        // 2. 키워드 삭제
        g.keywords.forEach(k=>{
          if(k.isDeleted) {
            let prevIndex = deleteKeywordParams.kwGroupSeqs.findIndex(groupSeq=> groupSeq == g.groupSeq);
            if(prevIndex == -1) {
              deleteKeywordParams.kwGroupSeqs.push(g.groupSeq);
              deleteKeywordParams.kwSeqs.push([k.kwSeq]);
            } else {// 이미 해당 그룹에 대한 다른 삭제할 키워드가 있다면
              deleteKeywordParams.kwSeqs[prevIndex].push(k.kwSeq);
            }
          }
        })

        // 3. 기존 그룹 수정
        if(g.isModified){
          if(!g.isNew) {
            modifyGroupParams.kwGroupSeqs.push(g.groupSeq);
            let cleanedName = g.groupName.split(' ').filter(Boolean).join(' '); // 두 개 이상의 공백은 하나의 공백으로 치환.
            modifyGroupParams.groupNames.push(cleanedName);
          }
        }
      }

      // 4. 새 그룹 추가
      if(g.isNew){
        if(!g.isDeleted) {
          let cleanedName = g.groupName.split(' ').filter(Boolean).join(' '); // 두 개 이상의 공백은 하나의 공백으로 치환.
          addGroupParams.groupNames.push(cleanedName);
        }
      }
    };

    // API 호출하기 ==================================================================
    if(deleteGroupParams.kwGroupSeqs.length !== 0) {// 그룹 삭제
      await commonJS.httpAPI("/user/keyword/group", "DELETE", deleteGroupParams, {
        headers: { "Content-Type": "application/json" }
      });
    }
    if(deleteKeywordParams.kwGroupSeqs.length !== 0) {// 키워드 삭제
      await commonJS.httpAPI("/user/keyword", "DELETE", deleteKeywordParams, {
        headers: { "Content-Type": "application/json" }
      });
    }
    if(modifyGroupParams.kwGroupSeqs.length !== 0) {// 기존 그룹 수정
      await commonJS.httpAPI("/user/keyword/group", "PATCH", modifyGroupParams, {
        headers: { "Content-Type": "application/json" }
      });
    }
    if(addGroupParams.groupNames.length !== 0) {// 새 그룹 추가
      await commonJS.httpAPI("/user/keyword/group", "POST", addGroupParams, {
        headers: { "Content-Type": "application/json" }
      });
    }

    userKeywordGroupStore.$showKeywordList();
    closeEditGroupOverlay();

  };

  /**
   * 그룹 관리 작업창 닫기 기능
   */
  function closeEditGroupOverlay() {
    resetAll();

    userKeywordGroupStore.isKeywordGroupOverlayOn = false;
  };

</script>

<style scoped>
.input-border-effect {
  border: 1px solid #ABABAB !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.input-border-effect:hover,
.input-border-effect:focus {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
/* 다크모드에서는 hover/focus 시에도 기본 색상 유지 */
.v-theme--darkTheme .input-border-effect:hover,
.v-theme--darkTheme .input-border-effect:focus {
  border-color: #ABABAB !important;
}

::v-deep(.select-border-effect .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__start) {
  border-bottom-width : 1px !important;
  border-bottom-color : black !important;
  border-left-width : 1px !important;
  border-left-color : black !important;
  border-top-width : 1px !important;
  border-top-color : black !important;
}
::v-deep(.select-border-effect .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__start) {
  border-color: #DDDDDD !important;
}

::v-deep(.select-border-effect .v-field--variant-outlined.v-field--focused .v-field__outline .v-field__outline__end) {
  border-bottom-width : 1px !important;
  border-bottom-color : black !important;
  border-right-width : 1px !important;
  border-right-color : black !important;
  border-top-width : 1px !important;
  border-top-color : black !important;
}
::v-deep(.select-border-effect .v-field--variant-outlined.v-theme--darkTheme.v-field--focused .v-field__outline .v-field__outline__end) {
  border-color: #DDDDDD !important;
}


#groupList .v-list-item--nav {
  padding-inline: 4px;
}
#keywordList .v-list-item--nav {
  padding: 4px !important;
  padding-inline: 4px !important;
}

.keyword-deletedGroup-border-effect {
  position: relative; /* 포지셔닝을 relative로 설정해서 오버레이를 그 안에 위치시키기 */
  border: 1px solid rgb(0, 0, 0, 0.87) !important;
  border-radius: 4px;
  transition: border-color 0.5s ease;
}
.keyword-deletedGroup-border-effect .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(169, 169, 169, 0.6); /* 연한 회색 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  z-index: 10;
}

.status-banner-container {
  width: 24px; /* 삭제/수정 배너 공간을 차지 */
  min-width: 24px; /* 삭제/수정 배너 공간을 차지 */
  margin: 0px 8px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-banner {
  width: 100%;
  height: 50%; /* input 높이의 절반 */
  color: white;
  padding: 0 2px;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.5;
  border-radius: 4px;
}

/* 저장된 검색어 텍스트 */
.keyword-text-from-edit-group {
  white-space: normal; /* 기본적인 줄바꿈 허용 */
  word-wrap: break-word; /* 단어 단위에서 줄바꿈 */
  overflow-wrap: break-word; /* 영역 크기를 초과하면 줄바꿈 */
  word-break: break-word; /* 연속된 긴 문자열도 줄바꿈 */
  font-size: 14px;
  cursor: pointer;
}


</style>
